import { TextEffects } from "@quickpoint.me/shared";
import getIndicesOf from "./getIndexOf";
import replaceText, { Replacement } from "./replaceText";

export default function replaceAnimatedText(text: string) {
    let animateIndexes = getIndicesOf(text, TextEffects.animate);
    const endAnimateIndexes = getIndicesOf(text, TextEffects.endAnimate, true);
    const instances: Replacement[] = [];
    endAnimateIndexes.forEach((endIndex) => {
        const start = animateIndexes[0];
        const instance = text.slice(start, endIndex);
        const words = instance.split(TextEffects.animate);
        words.shift();
        const html = `<span data-words='${JSON.stringify(words)}' id="${TextEffects.animate}" ></span>`;

        instances.push({ start, end: endIndex, replacement: html.replace(TextEffects.endAnimate, "") });
        animateIndexes = animateIndexes.filter((index) => index > endIndex);
    });

    if (animateIndexes.length > 0 && endAnimateIndexes.length === 0) {
        const start = animateIndexes[0];
        const instance = text.slice(start, text.length);
        const words = instance.split(TextEffects.animate);
        words.shift();
        const html = `<span data-words='${JSON.stringify(words)}' id="${TextEffects.animate}" ></span>`;
        instances.push({
            start,
            end: text.length,
            replacement: html.replace(TextEffects.endAnimate, ""),
        });
    }
    // replace the text with the html
    return replaceText(text, instances);
}